export default __webpack_public_path__ + "delivery-truck-silhouette.png";